/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enteranewpasswordforyouraccount6Inputs */

const en_enteranewpasswordforyouraccount6 = /** @type {(inputs: Enteranewpasswordforyouraccount6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter a new password for your account.`)
};

const de_enteranewpasswordforyouraccount6 = /** @type {(inputs: Enteranewpasswordforyouraccount6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gib ein neues Passwort für dein Konto ein.`)
};

/**
* | output |
* | --- |
* | "Enter a new password for your account." |
*
* @param {Enteranewpasswordforyouraccount6Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const enteranewpasswordforyouraccount6 = /** @type {((inputs?: Enteranewpasswordforyouraccount6Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enteranewpasswordforyouraccount6Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enteranewpasswordforyouraccount6(inputs)
	return de_enteranewpasswordforyouraccount6(inputs)
});
export { enteranewpasswordforyouraccount6 as "enterANewPasswordForYourAccount" }